exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scores-container[data-v-b0ae457a]{width:100%}", ""]);

// exports
